export default __webpack_public_path__ + "static/media/Courier-New-Bold-Italic.2e7ce385.ttf";